import { object, string, ref } from "yup";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const notMatchingPasswordsText = intl.formatMessage({ id: "app.form.notMatchingPasswords" });

  return object().shape({
    oldPassword: string().required(requiredText),
    newPassword: string()
      .required(requiredText)
      .oneOf([ref("confirmNewPassword"), null], notMatchingPasswordsText),
    confirmNewPassword: string()
      .required(requiredText)
      .oneOf([ref("newPassword"), null], notMatchingPasswordsText),
  });
};
